/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_History_StopInputs */

const vi_vehicle_gps_history_stop = /** @type {(inputs: Vehicle_Gps_History_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dừng`)
};

/**

* @param {Vehicle_Gps_History_StopInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_history_stop = /** @type {((inputs?: Vehicle_Gps_History_StopInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_History_StopInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_history_stop(inputs)
});